import type {CharacterState} from './character-state';

/** выбор языков раньше был у вида, теперь у происхождения */
const MOVED_CHOICES: [from: string, to: string][] = [['specie/languages#0', 'origin/languages#0']];

/** старые листы под новую модель: переносит выборы, ключи которых поменялись */
export function migrateState(state: CharacterState): CharacterState {
	let choices = state.choices;
	for (const [from, to] of MOVED_CHOICES) {
		if (!choices[from] || choices[to]) continue;
		const {[from]: moved, ...rest} = choices;
		choices = {...rest, [to]: moved};
	}
	return choices === state.choices ? state : {...state, choices};
}
